import { FC } from "react"

import ActivityTable from "../../activity/table"
import { Activity } from "../../../../types"

interface Props {
  data: Activity[]
  isFetching: boolean
  refetch: () => void
}

const OrgActivities: FC<Props> = ({ data, isFetching, refetch }) => {
  return (
    <div className="px-6 bg-white">
      <ActivityTable
        data={data}
        isLoading={isFetching}
        searchBarVisible={false}
        refetch={refetch}
      />
    </div>
  )
}

export default OrgActivities
